<div  class="dropzone-container">
    <label (click)="inputFile.click()" for="file" class="dropzone-text">Selecione ou arraste arquivos para cá
        <!-- <ng-container *ngIf="fileState.length > 0"><span ><br>{{fileState[0].name}}</span></ng-container> -->
        
    </label>
    <p class="subtitle">Tamanho máximo de upload de arquivo: 10MB.</p>
    <div  #display  class="display" ></div>
    <input #inputFile  type="file" name="file" id="" accept="image/*" [multiple]="multiple" (change)="onFileDropped($event)">   
</div>